import { buildReasonPage } from './reasonPageBuilder';
import { apportionmentInformationText as txt } from '../../definitions/constants';
import { FIELDS, YES_NO, noPriorAnswerYes } from './helpers';

export default buildReasonPage({
  path: 'veteran-support-and-medical-care',
  title: txt.veteranSupportPageTitle,
  description: txt.reasonPageSubDescription,
  depends: formData =>
    noPriorAnswerYes(formData, [
      FIELDS.veteranIncarceratedOver60Days,
      FIELDS.survivingBeneficiaryIncarceratedOver60Days,
      FIELDS.veteranIncompetentInCare,
    ]),
  trigger: {
    name: FIELDS.veteranReceivingPensionInCare,
    title: txt.veteranReceivingPensionInCareTitle,
    hint: txt.veteranSupportHintText,
    labels: txt.veteranPensionLabels,
    descriptions: txt.veteranPensionDescriptions,
    tile: true,
    options: YES_NO,
    error: txt.veteranPensionError,
  },
  conditionalFields: [
    {
      type: 'text',
      name: FIELDS.veteranPensionFacilityName,
      title: txt.veteranCareFacilityNameTitle,
      maxLength: 150,
      error: txt.veteranPensionFacilityNameError,
    },
    {
      type: 'text',
      name: FIELDS.veteranPensionFacilityAddress,
      title: txt.facilityAddressTitle,
      maxLength: 500,
      error: txt.veteranPensionFacilityAddressError,
    },
  ],
});
